import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { API } from '../config/api';
import { CheckCircle, Heart, ArrowLeft, Loader2 } from 'lucide-react';

export default function TipSuccessPage() {
  const [params] = useSearchParams();
  const { getAuthHeaders } = useAuth();
  const [confirming, setConfirming] = useState(true);
  const [result, setResult] = useState(null);

  const tipId = params.get('tip_id');
  const sessionId = params.get('session_id');

  useEffect(() => {
    if (!tipId) { setConfirming(false); return; }
    const confirm = async () => {
      try {
        const res = await fetch(`${API}/monetization/tip/confirm/${tipId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) setResult(await res.json());
      } catch {} finally {
        setConfirming(false);
      }
    };
    confirm();
  }, [tipId, sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="tip-success-page">
      <Card className="max-w-md w-full p-8 text-center bg-card/50 border border-border">
        {confirming ? (
          <div className="flex flex-col items-center gap-4">
            <Loader2 className="w-12 h-12 animate-spin text-muted-foreground" />
            <p className="text-muted-foreground">Confirming your tip...</p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-500" />
            </div>
            <h1 className="text-2xl font-bold">Tip Sent!</h1>
            {result?.amount && (
              <p className="text-lg text-emerald-400 font-bold">${result.amount.toFixed(2)}</p>
            )}
            <p className="text-muted-foreground">
              Thank you for supporting this creator! <Heart className="w-4 h-4 inline text-pink-500" />
            </p>
            <Link to="/feed">
              <Button variant="outline" className="gap-2 mt-2">
                <ArrowLeft className="w-4 h-4" /> Back to Feed
              </Button>
            </Link>
          </div>
        )}
      </Card>
    </div>
  );
}
